import { render, staticRenderFns } from "./HRPost.vue?vue&type=template&id=8d8bb2f0&scoped=true"
import script from "./HRPost.vue?vue&type=script&lang=js"
export * from "./HRPost.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8d8bb2f0",
  null
  
)

export default component.exports